import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-514"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.502 10.3H4.525a.5.5 0 0 0 0 1h8.977a.5.5 0 0 0 0-1zM15.5 4.188h-.702a3.176 3.176 0 0 0-2.983-2.102 3.146 3.146 0 0 0-.396.04 4.675 4.675 0 0 0-7.838 0 3.146 3.146 0 0 0-.397-.04 3.185 3.185 0 1 0 1.244 6.116 4.61 4.61 0 0 0 6.144 0A3.185 3.185 0 0 0 15 5.27c0-.028-.008-.054-.008-.082h.508a.5.5 0 0 0 0-1zM14 5.27a2.162 2.162 0 0 1-.068.516H5.996a.5.5 0 1 0 0 1h7.386a2.177 2.177 0 0 1-2.42.496 1 1 0 0 0-1.048.167 3.61 3.61 0 0 1-4.828 0 1 1 0 0 0-1.049-.167 2.185 2.185 0 1 1-.852-4.196 1.22 1.22 0 0 1 .168.018l.104.014a1 1 0 0 0 .96-.444 3.675 3.675 0 0 1 6.165 0 1 1 0 0 0 .961.444l.104-.014a1.22 1.22 0 0 1 .168-.018 2.177 2.177 0 0 1 1.886 1.102H8.47a.5.5 0 0 0 0 1h5.523c0 .028.008.054.008.082zm-3.017 7.343a.5.5 0 0 0-.5-.5H1.508a.5.5 0 1 0 0 1h8.975a.5.5 0 0 0 .5-.5zm1.111 1.344H3.118a.5.5 0 1 0 0 1h8.976a.5.5 0 0 0 0-1z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }